const endpoints = {
    vocales:'/vocales',
    elecciones:'/elecciones',
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}
